import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
class QuicksightEmbeddingContext {
  static context;

  async createQuicksightEmbeddingContext(resolve) {
    QuicksightEmbeddingContext.context = await createEmbeddingContext();
    resolve();
  }

  get embeddingContext() {
    return QuicksightEmbeddingContext.context;
  }
}

export default QuicksightEmbeddingContext;
